import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { transformResponseHandler } from 'utils/transformResponseHandler';

export const foodItemApi = createApi({
    reducerPath: 'foodItemApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_API_ROUTE}/pos`,
        prepareHeaders: (headers, { getState }) => {
            const token = getState()?.posData?.token;
            if (token) {
                headers.set('Authorization', token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
         getListFoodItems: builder.query({
            // accept an object with optional category & search
            query: ({ category } = {}) => {
            const params = {}
            if (category != null) params.category = category
            return {
                url: '/food-items',
                method: 'GET',
                params,      // fetchBaseQuery will serialize this into ?category=…&search=…
            }
            },
            providesTags: ['foodItem'],
            transformErrorResponse: (err) => transformResponseHandler(err),
        }),
        addFoodItem: builder.mutation({
            query: (body) => ({
                url: '/food-items',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['foodItem'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        updateFoodItem: builder.mutation({
            query: ({ id, ...body }) => ({
                url: `/food-items/${id}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['foodItem'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        deleteFoodItem: builder.mutation({
            query: (id) => ({
                url: `/food-items/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['foodItem'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        changeFoodItemStatus: builder.mutation({
            query: ({ id, body }) => ({
                url: `/food-items/change-status/${id}`,
                method: 'PUT',
                body: { status: body },
            }),
            invalidatesTags: ['foodItem'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
    }),
});

export const {
    useAddFoodItemMutation,
    useUpdateFoodItemMutation,
    useGetListFoodItemsQuery,
    useDeleteFoodItemMutation,
    useChangeFoodItemStatusMutation
} = foodItemApi;
